export default {
  homePriceMin: 0,
  homePriceMax: 10000000,
  homePriceFrom: 0,
  homePriceTo: 10000000,
  homeAreaMin: 0,
  homeAreaMax: 100000,
  homeAreaFrom: 0,
  homeAreaTo: 100000,
  buildersArray: [],
  bedMin: 0,
  bedMax: 10,
  bedFrom: 0,
  bedTo: 10,
  bedArray: [],
  bathMin: 0,
  bathMax: 0,
  bathFrom: 0,
  bathTo: 0,
  bathArray: [],
  storeyArray: [],
  carArray: [],
  carFrom: 0,
  tour: false,
  quickMovein: false,
  sortBy: 'price-low'
}



// WEBPACK FOOTER //
// ./src/model/HomeFilter.js